import React from 'react'
import PropTypes from 'prop-types'
import {CarouselNext, CarouselPrevious} from '@/components/ui/carousel'
import SvgChevronLeft from '@/assets/icons/chevron-left'
import SvgChevronRight from '@/assets/icons/chevron-right'
import {CircleArrowLeft, CircleArrowRight} from 'lucide-react'

const carouselIconNamesMap = {
    'Circle Arrow': {
        previous: CircleArrowLeft,
        next: CircleArrowRight
    },
    Chevron: {
        previous: SvgChevronLeft,
        next: SvgChevronRight
    }
}

export const iconNames = Object.keys(carouselIconNamesMap).map((iconName) => iconName)

const carouselButtonComponentMap = {
    previous: CarouselPrevious,
    next: CarouselNext
}

export const CustomCarouselButton = (props) => {
    const {type, icon, overlapContent, fillColor = 'hsl(var(--background))', attributes} = props
    const CarouselButton = carouselButtonComponentMap[type]
    const buttonIcon = carouselIconNamesMap[icon][type]

    return (
        <CarouselButton
            overlapContent={overlapContent}
            fillColor={fillColor}
            buttonIcon={buttonIcon}
            iconAttributes={attributes}
            data-testid="carouselButton-CarouselButton"
        />
    )
}

CustomCarouselButton.propTypes = {
    attributes: PropTypes.object,
    icon: PropTypes.string,
    fillColor: PropTypes.string,
    type: PropTypes.string.isRequired,
    overlapContent: PropTypes.bool
}

export const CarouselButtonDefinition = {
    component: CustomCarouselButton,
    name: 'CarouselButton',
    noWrap: true,
    inputs: [
        {name: 'type', type: 'string', enum: ['previous', 'next'], required: true},
        {name: 'icon', type: 'string', enum: iconNames, defaultValue: 'Circle Arrow'},
        {name: 'fillColor', type: 'color'},
        {name: 'overlapContent', type: 'boolean', defaultValue: false}
    ]
}
